<template>
  <div>
    活动
  </div>
</template>

<script>
export default {
  name: "Activity",
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>

</style>
